const Window = {
  invoke: {
    postMessage: ([url, target]: [string, string]) => {
      window.top.postMessage(url, target);
    },
    getInnerWidth: () => window.innerWidth,
    openUsabilla: () => {
      try {
        window.usabilla_live('click');
      } catch (e) {
        console.error('Could not open feedback.');
      }
    },
    openSite: ([url]: [string, string]) => {
      const a = document.createElement('a');
      a.href = url;
      a.click();
    },
    redirectToUrl: (url: string) => {
      window.location.href = url;
    },
    handleOpenInIframe: () => {
      if (window.self !== window.top) {
        window.top.location = window.location;
      }
    },
    getInitialPresenterLayout: () => {
      return window.initialPresenterLayout;
    },
    getAssemblerContext: () => {
      return window.ASSEMBLER?.CONTEXT || {};
    },
    getKraken: () => window.kraken,
  },
};

export default Window;
